import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref } from "vue"

import Vue, {
    onMounted,
    ref,
    watch,
    defineAsyncComponent,
    onBeforeUnmount,
    computed,
} from "vue";
import { admDateList, configAdmList, admDateListAdUnit } from "@/api/api";
import XDialog from "@/components/XDialog.vue";
import { notification } from "ant-design-vue";
import { onBeforeRouteLeave } from "vue-router";
import { useStore } from "vuex";
import dayjs, { Dayjs } from "dayjs";


export default /*#__PURE__*/_defineComponent({
  __name: 'ads',
  props: {
    appData: {},
    dateTime: {},
    isRefresh: { type: Boolean },
    dbName: {}
  },
  setup(__props: any) {

const XATable = defineAsyncComponent(() => import("../components/XATable.vue"));
const store = useStore();
const props = __props;
const currentAppId = ref("");
const rightAppIdVal = ref<any[]>([]);
var appIdList: any[] = [];
const maxTagCount = ref(1);
const checkedValue = ref(true);
const configList = ref<any>([]);
const dateValue = ref("");
const pageNo = ref(1);
const activeKey = ref(-1)
const detailVisible = ref(false)
const detailLoading = ref(false)
const adsTitle = ref("详情")
const curDetailRow = ref<any>({})

const columns = ref([
    {
        title: "日期",
        key: "date",
        dataIndex: "date",
    },
    {
        title: "请求数",
        key: "adRequests",
        dataIndex: "adRequests",
    },
    {
        title: "点击数",
        key: "clicks",
        dataIndex: "clicks",
    },
    {
        title: "展示数",
        key: "impressions",
        dataIndex: "impressions",
    },
    {
        title: "点击率",
        key: "impressionCtr",
        dataIndex: "impressionCtr",
        slots: {
            customRender: "impressionCtr",
        },
    },
    {
        title: "成功请求数",
        key: "matchedRequests",
        dataIndex: "matchedRequests",
    },
    {
        title: "媒合率",
        key: "matchRate",
        dataIndex: "matchRate",
        slots: {
            customRender: "matchRate",
        },
    },
    {
        title: "有效千次曝光出价",
        key: "observedEcpm",
        dataIndex: "observedEcpm",
        slots: {
            customRender: "observedEcpm",
        },
    },
    {
        title: "预估收入",
        key: "estimatedEarnings",
        dataIndex: "estimatedEarnings",
        slots: {
            customRender: "estimatedEarnings",
        },
    },
    {
        title: "操作",
        key: "control",
        dataIndex: "control",
        slots: {
            customRender: "control",
        },
    },
]);
const detailColumns = ref([
    {
        title: "广告位",
        key: "adUnitName",
        dataIndex: "adUnitName",
    },
    {
        title: "请求数",
        key: "adRequests",
        dataIndex: "adRequests",
    },
    {
        title: "点击数",
        key: "clicks",
        dataIndex: "clicks",
    },
    {
        title: "展示数",
        key: "impressions",
        dataIndex: "impressions",
    },
    {
        title: "点击率",
        key: "impressionCtr",
        dataIndex: "impressionCtr",
        slots: {
            customRender: "impressionCtr",
        },
    },
    {
        title: "成功请求数",
        key: "matchedRequests",
        dataIndex: "matchedRequests",
    },
    {
        title: "媒合率",
        key: "matchRate",
        dataIndex: "matchRate",
        slots: {
            customRender: "matchRate",
        },
    },
    {
        title: "有效千次曝光出价",
        key: "observedEcpm",
        dataIndex: "observedEcpm",
        slots: {
            customRender: "observedEcpm",
        },
    },
    {
        title: "预估收入",
        key: "estimatedEarnings",
        dataIndex: "estimatedEarnings",
        slots: {
            customRender: "estimatedEarnings",
        },
    },
]);
const tableData = ref([]);
const detailTableData = ref([]);
const loading = ref(false);
let timerInval = ref();
var BackOrderIds: any[] = [];

const getRequestData = () => {
    loading.value = true;
    admDateList({
        appId: currentAppId.value,
        // pageNo: pageNo.value,
        // pageSize: pageSize.value,
        beginTime: dayjs(dateValue.value[0]).format("YYYY-MM-DD"),
        endTime: dayjs(dateValue.value[1]).format("YYYY-MM-DD"),
    }).then((res) => {
        loading.value = false;
        res.data.forEach((element: any) => {
            if (!element.date) {
                element.date = "汇总"
            }
        });
        tableData.value = res.data;
    });
};
// 监听 Vuex 的 refreshNeeded 状态
const refreshNeeded = computed(() => store.state.refundRefreshNeeded);

// 监控 refreshNeeded 的变化
watch(refreshNeeded, (newValue) => {
    if (newValue) {
        // 执行页面刷新操作
        getRequestData();
        // 重置刷新状态
        store.dispatch("resetRefundRefresh");
    }
});

watch(
    () => props.isRefresh,
    (cur, old) => {
        if (rightAppIdVal.value.length) {
            getRequestData();
        }
    }
);

watch(
    () => props.dateTime,
    (cur, old) => {
        //console.log(cur)
        dateValue.value = cur;
        getRequestData();
    },
    {
        immediate: true,
    }
);

const tabClick = (tabIndex: any) => {
    if (tabIndex === -1) {
        currentAppId.value = "";
    } else {
        const item: any = configList.value[tabIndex];
        currentAppId.value = item.appId;
    }
    getRequestData();
};
const pageChange = (page: any) => {
    pageNo.value = page;
    getRequestData();
};
const getConfigList = () => {
    configAdmList({}).then((res) => {
        //console.log(res)
        configList.value = res.data;
    });
};
const confirmDetail = (row: any) => {
    curDetailRow.value = row
    adsTitle.value = row.appName + "广告详情" + "(" + row.date + ")"
    detailVisible.value = true
    detailLoading.value = true
    var beginTime = row.date
    var endTime = row.date
    if (row.date === "汇总") {
        beginTime = dayjs(dateValue.value[0]).format("YYYY-MM-DD")
        endTime = dayjs(dateValue.value[1]).format("YYYY-MM-DD")
    }
    admDateListAdUnit({
        appId: row.appId,
        beginTime: beginTime,
        endTime: endTime
    }).then(res => {
        detailLoading.value = false
        detailTableData.value = res.data
    })
}
onMounted(() => {
    checkedValue.value = store.state.refundCheckedValue;
    dateValue.value = props.dateTime;
    getConfigList();
    getRequestData();
});

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_tabs, {
      activeKey: activeKey.value,
      "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((activeKey).value = $event)),
      onTabClick: tabClick
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_component_a_tab_pane, {
          key: -1,
          tab: "全部"
        })),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(configList.value, (item, index) => {
          return (_openBlock(), _createBlock(_component_a_tab_pane, {
            key: index,
            tab: item.appName,
            disabled: loading.value
          }, null, 8, ["tab", "disabled"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["activeKey"]),
    _createVNode(_unref(XATable), {
      columns: columns.value,
      dataSource: tableData.value,
      scroll: { x: 1500 },
      loading: loading.value
    }, {
      estimatedEarnings: _withCtx(({ scope }) => [
        _createElementVNode("span", null, "$" + _toDisplayString((scope.record.estimatedEarnings / 100).toFixed(2)), 1)
      ]),
      observedEcpm: _withCtx(({ scope }) => [
        _createElementVNode("span", null, "$" + _toDisplayString((scope.record.observedEcpm / 100).toFixed(2)), 1)
      ]),
      impressionCtr: _withCtx(({ scope }) => [
        _createElementVNode("span", null, _toDisplayString((scope.record.impressionCtr * 100).toFixed(2)) + "%", 1)
      ]),
      matchRate: _withCtx(({ scope }) => [
        _createElementVNode("span", null, _toDisplayString((scope.record.matchRate * 100).toFixed(2)) + "%", 1)
      ]),
      control: _withCtx(({ scope }) => [
        _createVNode(_component_a_button, {
          disabled: activeKey.value == -1,
          type: "link",
          onClick: ($event: any) => (confirmDetail(scope.record))
        }, {
          default: _withCtx(() => [
            _createTextVNode("详情")
          ]),
          _: 2
        }, 1032, ["disabled", "onClick"])
      ]),
      _: 1
    }, 8, ["columns", "dataSource", "loading"]),
    _createVNode(XDialog, {
      visible: detailVisible.value,
      title: adsTitle.value,
      xWidth: "100%",
      onCancel: _cache[1] || (_cache[1] = ($event: any) => (detailVisible.value = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(XATable), {
          columns: detailColumns.value,
          dataSource: detailTableData.value,
          scroll: { x: 1500 },
          loading: detailLoading.value
        }, {
          estimatedEarnings: _withCtx(({ scope }) => [
            _createElementVNode("span", null, "$" + _toDisplayString((scope.record.estimatedEarnings / 100).toFixed(2)), 1)
          ]),
          observedEcpm: _withCtx(({ scope }) => [
            _createElementVNode("span", null, "$" + _toDisplayString((scope.record.observedEcpm / 100).toFixed(2)), 1)
          ]),
          impressionCtr: _withCtx(({ scope }) => [
            _createElementVNode("span", null, _toDisplayString((scope.record.impressionCtr * 100).toFixed(2)) + "%", 1)
          ]),
          matchRate: _withCtx(({ scope }) => [
            _createElementVNode("span", null, _toDisplayString((scope.record.matchRate * 100).toFixed(2)) + "%", 1)
          ]),
          _: 1
        }, 8, ["columns", "dataSource", "loading"])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ], 64))
}
}

})